<template>
  <div class="media section">
    <container>
      <div class="media__wrp">
        <div class="media__header">
          <div class="media__title color-white">
            <span class="color-light-green">HolywoodSkyline</span> on Media<span class="color-light-green">.com</span>
          </div>
          <div class="media__header-right">
            <v-button
              class="circle media__button left"
              icon="icon-arrow-left"
              icon-position="left"
            />

            <v-button
              class="circle media__button right"
              icon="icon-arrow-right"
              icon-position="left"
            />
          </div>
        </div>

        <div class="media__cnt swiper-container">
          <swiper :options="swiperOption">
            <swiper-slide
              v-for="media in media"
              :key="media.id">
              <router-link to="about#media" class="media__item">
                <img :src="media.cover" alt="" class="media__img">
              </router-link>
            </swiper-slide>
            <div class="swiper-paginations" style="text-align: center;" slot="pagination"></div>
          </swiper>
        </div>
      </div>
    </container>
  </div>
</template>
<script>

export default {
  name: 'Media',
  data () {
    return {
      media: [
        {
          id: 0,
          cover: require('@/assets/img/networks/netflix.jpg')
        },
        {
          id: 1,
          cover: require('@/assets/img/networks/cn.png')
        },
        {
          id: 2,
          cover: require('@/assets/img/networks/disney.jpg')
        },
        {
          id: 3,
          cover: require('@/assets/img/networks/hbo.jpg')
        },
        // {
        //   id: 4,
        //   cover: require('@/assets/img/networks/guncelhaber.png')
        //
        // },
        {
          id: 5,
          cover: require('@/assets/img/networks/amc.png')
        },
        {
          id: 6,
          cover: require('@/assets/img/networks/abc.png')

        },
        // {
        //   id: 7,
        //   cover: require('@/assets/img/networks/kamilkoc.png')
        //
        // },
         {
           id: 8,
           cover: require('@/assets/img/networks/hulu.jpg')
        
         },
        {
          id: 9,
          cover: require('@/assets/img/networks/bbc.jpg')

        },
        {
          id: 10,
          cover: require('@/assets/img/networks/primevideo.png')

        }
        // {
        //   id: 12,
        //   cover: require('@/assets/img/networks/yeniasya.png')
        //
        // },
        // {
        //   id: 13,
        //   cover: require('@/assets/img/networks/sivasınsesi.png')
        //
        // },
        // {
        //   id: 14,
        //   cover: require('@/assets/img/networks/yurtgundemi.png')
        //
        // }
      ],
      swiperOption: {
        slidesPerView: 8,
        spaceBetween: 50,
        breakpoints: {
          640: {
            slidesPerView: 3,
            slidesPerGroup: 3
          },
          320: {
            slidesPerView: 2,
            slidesPerGroup: 2
          }
        },
        pagination: {
          el: '.swiper-paginations',
          clickable: true
        },
        navigation: {
          nextEl: '.media__button.right',
          prevEl: '.media__button.left'
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>

  .swiper-paginations{
    margin-top: 20px;
  }
  @import "../../assets/scss/components/media";
</style>
